export const ERROR_CODES = Object.freeze({
  // BadRequest request validation error
  BAD_REQUEST: 400400,
  // NotAuthorized to access this resource
  NOT_AUTHORIZED: 400403,
  // NotLicensed user doesn't have an active license
  NOT_LICENSED: 400406,
  // InvalidUsername username is wrong
  INVALID_USERNAME: 400407,
  // InvalidPassword password is wrong
  INVALID_PASSWORD: 400408,
  // Deactivated user
  DEACTIVATED: 400409,
  // InvalidToken token is not valid
  INVALID_TOKEN: 400410,
  // InvalidMFA mfa is not valid
  INVALID_MFA: 400411,
  // InvalidRecoveryCode recovery code is not valid
  INVALID_RECOVERY_CODE: 400412,
  // InvalidBarcode barcode is not valid
  INVALID_BARCODE: 400413,
  // InvalidUserStatus user needs to progress properly through statuses
  INVALID_USER_STATUS: 400414,
  // InvalidCollectionDate min date is 1 day from now, max date is 7 days from now
  INVALID_COLLECTION_DATE: 400415,
  // InvalidData data is not valid
  INVALID_DATA: 400416,
  // DownstreamServiceError internal issue while communicating to downstream service
  DOWNSTREAM_SERVICE_ERROR: 500419,
  // GenerateJWTError internal issue while generating jwt
  GENERATE_JWT_ERROR: 500500,
  // InternalGetError while fetching resource
  INTERNAL_GET_ERROR: 500505,
  // InternalInsertError while inserting resource
  INTERNAL_INSERT_ERROR: 500506,
  // InternalUpdateError while updating resource
  INTERNAL_UPDATE_ERROR: 500507,
  // InternalDeleteError while deleting resource
  INTERNAL_DELETE_ERROR: 500508,
  // InternalParsingError while trying to parse import resource
  INTERNAL_PARSING_ERROR: 600600,
  // InvalidImportFileType unsupported file type was provided as import file
  INVALID_IMPORT_FILE_TYPE: 600601,
  // ToManyActiveSessionsError
  TO_MANY_ACTIVE_SESSIONS_ERROR: 700700,
  // InstanceNotRunningError -- instance is not running
  INSTANCE_NOT_RUNNING_ERROR: 700701,
} as const);
